module.exports = __webpack_public_path__ + "static/media/bg.13d9fb89.jpg";